// axios
//set NODE_OPTIONS=--max-old-space-size=104096
import axios from 'axios'
import _ from "lodash";
import moment from "moment";

let domain ="http://localhost:8000/"
if (window.location.host=="app.tfsfinserv.com") {
 domain ="https://api.tfsfinserv.com/"
}

let anonymousLogin =false;

const instance = axios.create({
    baseURL:domain
  // You can add your headers here
})

instance.interceptors.request.use(function(config) {
  var token = localStorage.getItem("token");
    if(!_.has(config['data'] ,"timezone") ){
      config['data']['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;//moment.tz.guess()
    }
     config.headers['Content-Type'] = 'application/json'
    if ( token != null ) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if(_.has(config, 'data')){
      if(!_.has(config['data'] ,"today")){
        config['data']['today'] = moment().format("YYYY-MM-DD")
      }

      if(!_.has(config['data'] ,"timezone") ){
        config['data']['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;//moment.tz.guess()
      }
      // moment.tz.guess()
    }
    
    return config;
  }, function(err) {
    return Promise.reject(err);
  });

  
//   instance.interceptors.response.use(
//     function(response){     
//       return response;
//     }, 
//     function(error){
//         // handle error LOGIN_USER_INACTIVE
//         let err = _.cloneDeep(error);
//         if(error && _.has(error,'response' ) && _.has(error.response ,"data" ) && _.has(error.response.data ,"result" ) && _.has(error.response.data.result ,"error" ) &&  _.has(error.response.data.result.error ,"code" )  ){
//           if(error.response.data.result.error.code =='TOKEN_EXPIRED' || error.response.data.result.error.code =='LOGIN_USER_INACTIVE' || error.response.data.result.error.code =='ROLE_CHANGED' ){
//             localStorage.removeItem('token');
//             localStorage.removeItem('userRole');
//             localStorage.removeItem('user');
//             localStorage.removeItem('LS_ROUTE_KEY');
                       
           
           
//             //this.showToster({message:'sdhsdhfdsf',isError:true})
//            // alert(error.response.data.result.error.code)
           
           
//           }
         
//         }
            
//         return Promise.reject(error);
//         //return error;
//     });
   
   


export default instance;
export {domain}